import type { SVGProps } from "react"

import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const BackIcon = ({ size = 22, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 18l-6-6 6-6" />
  </svg>
)

export const BackChevronIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden focusable="false" {...props}>
    <path
      d="M5.85355 0.159761C5.65829 -0.0532537 5.34178 -0.0532537 5.14651 0.159761L0.146449 5.61434C-0.0488162 5.82736 -0.0488162 6.17264 0.146449 6.38566L5.14651 11.8402C5.34178 12.0533 5.65829 12.0533 5.85355 11.8402C6.04882 11.6272 6.04882 11.2819 5.85355 11.0689L1.20701 6L5.85355 0.931073C6.04882 0.718058 6.04882 0.372776 5.85355 0.159761Z"
      fill="currentColor"
    />
  </svg>
)
